import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import {
  WeightDto,
  DimensionDto,
} from "../../../core/models/project-workflow/dimensionDataDtos";
import { TrackingDetailsBindingDto } from "../../../core/models/project-workflow/trackingDetailsBindingDto";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
// fixes/14757: original PrimeNG tab-view import, no longer used after removing the tab UI
// import { TabViewModule } from "primeng/tabview";

@Component({
  selector: "jni-tracking-detail-popup",
  templateUrl: "./tracking-detail-popup.component.html",
  styleUrls: ["./tracking-detail-popup.component.scss"],
  // fixes/14757: imports: [TabViewModule, CommonModule],
  imports: [CommonModule, ButtonModule],
})
export class TrackingDetailPopupComponent implements OnChanges {
  //@Input() modalOpen = false;
  @Input() trackingNumberDetail = {} as TrackingDetailsBindingDto;
  @Input() trackingWeight: WeightDto[] = [];
  @Input() trackingDimension: DimensionDto[] = [];
  @Input() isUPS = false;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() viewTimelineEvent = new EventEmitter<void>();
  showTabs = false;

  ngOnChanges() {
    if (
      this.trackingNumberDetail?.deliveryStatus &&
      this.trackingNumberDetail?.deliveryStatus !== "" &&
      this.trackingNumberDetail?.deliveryStatus.toLowerCase() !== "pending"
    ) {
      this.showTabs = true;
    }
  }

  onHide() {
    this.displayChange.emit(false);
  }

  onViewTimeline() {
    this.viewTimelineEvent.emit();
  }
}
